export class TypeDept {

    public deptPub: String;
    public rappel: Array<String>;

    constructor(){
        this.rappel = [];
        this.deptPub = '';
    }

}
